<template>
    <div id="cms">
        <!-- ==================================
            this page is creating News page
        ======================================-->
        
        <h1  v-if="$store.state.token">Create a new post</h1>
        <br>
        <div class="container" v-if="$store.state.token">

            <div class="block">
                <!-- titles -->
                <div class="form">
                    <input type="text" class="en" v-model="titleEn" placeholder="English title">
                    <input type="text" class="ar" v-model="titleAr" placeholder="العنوان العربي">
                </div>

                <!-- describtions -->
                <div class="form">
                    <textarea v-model="descEn" class="en" placeholder="English describtion"></textarea>
                    <textarea v-model="descAr" class="ar" placeholder="الوصف لعربي"></textarea>
                </div>

                <!-- date - upload img -->
                <div class="form">
                    <button class="square" @click="selectImg()">Upload image</button>
                    
                    <date-picker format="YYYY-MM-DD"
                        placeholder="Select date" 
                        v-model="time1" 
                        valueType="format" 
                        input-class="my-date-input"></date-picker>
                </div>


                <!-- save post - progress - display img -->
                <div class="form diffrent">
                    <input ref="imgFiler" type="file" id="imageInput" accept="image/*" @change="onImageChange" v-show="false">

                    <img v-if="imagePreview" :src="imagePreview" width="500px" class="preview-img" />

                    <br><br>
                    <p v-if="uploadProgress>0">{{ uploadProgress==100? 'done':'Uploading...' }} {{ uploadProgress }}%</p>
                    <div v-if="uploadProgress>0" class="progress"><div :style="{width: `${uploadProgress}%`}"></div></div>
                    
                    <button class="square" @click="sendNews()">save post</button>
                </div>



            </div>
        </div>

        <!-- unauthorized  -->
        <div class="container" v-else>
            <b style="font-size: 2em;">Unauthorized</b>
            <span>This page need authorized access to continue</span>
            <router-link tag="button" class="square" :to="{name: 'cmsLogin'}">Log in</router-link>

            <router-link :to="{name: 'updatePost'}" tag="button"  class="square">Update Post</router-link>
        </div>

    </div>
</template>


<script>
    import api from '@/apis';
import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';

  export default {
    components: { DatePicker },
    data() {
        return {
            time1: null,
            titleAr: "",
            titleEn: "",
            descAr: "",
            descEn: "",

            imageFile: null,
            imagePreview: null,

            uploadProgress: 0,
        }
    },
    methods: {
        selectImg() {
            this.$refs.imgFiler.click();
        },
        onImageChange(e) {
            const file = e.target.files[0];
            if (!file) return;

            if (!file.type.startsWith("image/")) {
                alert("Only image files are allowed");
                return;
            }

            this.imagePreview = URL.createObjectURL(file);
            this.imageFile = file;
        },
        sendNews() {
            if (!this.imageFile) {
                alert("Please select an image first");
                return;
            }

            const formData = new FormData();
            formData.append("date", this.time1);
            formData.append("title_ar", this.titleAr);
            formData.append("title_en", this.titleEn);
            formData.append("body_ar", this.descAr);
            formData.append("body_en", this.descEn);
            formData.append("image", this.imageFile); // the actual file


            console.log(formData);
            
            api.post('/news/create', formData, {
                headers: {  
                    Authorization: `Bearer ${this.$store.state.token}`,
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: progressEvent => {
                    const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    console.log("Upload Progress:", percent + "%");
                    this.uploadProgress = percent; // optional: for a progress bar
                }
            })
            .catch(err => {
                console.error("Upload error", err);
                this.uploadProgress = 0; // reset on error
            });
        }



    },
    mounted() {

    }
  }
</script>